import React, { useState, useContext, useEffect } from "react";

import { Link } from "react-router-dom";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// Styles
import styles from "./DashboardFileManagement.module.css";

//Images
import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg";
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg";
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg";
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg";
import ConsultantLimitationModal from "./ConsultantLimitationModal/ConsultantLimitationModal";
import axios from "axios";
import ChangeColumnVisibility from "../../ChangeColumnVisibility/ChangeColumnVisibility";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);

const FileManagmentCards = props => {
  const [selectedTable, setSelectedTable] = useState();
  const { userToken, permissions, consultantData } = useContext(UserContext);
  const [limitationModal, setLimitationModal] = useState({
    open: false,
    fileID: "",
  });

  const [ownerDetailLimit, setOwnerDetailLimit] = useState(true);

  const history = useHistory();

  let [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategoriesData(res.data?.data || []);
      });
  }, []);

  // Get Limites
  useEffect(() => {
    async function getLimits() {
      const limitConsultant = await axios
        .get(`ConsultantLimiting/ConsultantLimitFields?consultantId=${consultantData?.id}`, {
          headers: { authorization: "Bearer " + userToken },
        })
        .then(res => {
          return res;
        });
      const limitItemsForConsultant = (await permissions?.find(item => item === 15))
        ? null
        : limitConsultant.data?.data?.fileItems?.map(item => item.fieldName) ?? null;

      setOwnerDetailLimit(limitItemsForConsultant?.some(limit => limit == "OwnerDetail") || false);
    }

    getLimits();
  }, [consultantData?.id, permissions, userToken]);

  function getParentCategory(categoryId) {
    let parentId = 0;
    categoriesData.forEach(category => {
      if (category.id == categoryId) {
        parentId = category.parentId;
      }
    });

    return parentId;
  }

  const tables = [
    {
      id: 0,
      headers: [
        {
          id: 0,
          title: "شناسه",
          isVisible: localStorage.getItem(`0-0-visibility`) === "false" ? false : true,
        },
        {
          id: 1,
          title: "متراژ",
          isVisible: localStorage.getItem(`0-1-visibility`) === "false" ? false : true,
        },
        {
          id: 2,
          title: "طبقه",
          isVisible: localStorage.getItem(`0-2-visibility`) === "false" ? false : true,
        },
        {
          id: 3,
          title: "پارکینگ",
          isVisible: localStorage.getItem(`0-3-visibility`) === "false" ? false : true,
        },
        {
          id: 4,
          title: "سال ساخت",
          isVisible: localStorage.getItem(`0-4-visibility`) === "false" ? false : true,
        },
        {
          id: 5,
          title: props.dealType == 1 ? "رهن" : "کل",
          isVisible: localStorage.getItem(`0-5-visibility`) === "false" ? false : true,
        },
        {
          id: 6,
          title: props.dealType == 1 ? "اجاره" : "متری",
          isVisible: localStorage.getItem(`0-6-visibility`) === "false" ? false : true,
        },
        {
          id: 7,
          title: "موقعیت ملک",
          isVisible: localStorage.getItem(`0-7-visibility`) === "false" ? false : true,
        },
        {
          id: 8,
          title: "تعداد خواب",
          isVisible: localStorage.getItem(`0-8-visibility`) === "false" ? false : true,
        },
        {
          id: 9,
          title: "نام مالک",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`0-9-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
        {
          id: 10,
          title: "آدرس دقیق",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`0-10-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
      ],
      content(item, props) {
        return (
          <tr key={item.fileCode}>
            {this.headers[0]?.isVisible ? (
              <td>
                <Link to={`/card-detail/${item.id}`}>{item.fileCode?.match(/\d+/)[0]}</Link>
              </td>
            ) : null}
            {this.headers[1]?.isVisible ? (
              <td>
                <p> {item.meterage}</p>
              </td>
            ) : null}
            {this.headers[2]?.isVisible ? (
              <td>
                <p> {item.floor?.toString()}</p>
              </td>
            ) : null}
            {this.headers[3]?.isVisible ? (
              <td>
                <p> {item.parkingCount || 0}</p>
              </td>
            ) : null}
            {this.headers[4]?.isVisible ? (
              <td>
                <p> {item.constructionYear}</p>
              </td>
            ) : null}
            {this.headers[5]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.mortgagePrice : item.totalPrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[6]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.rentPrice : item.meteragePrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[7]?.isVisible ? (
              <td>
                <p> {item.positions || "نامشخص"}</p>
              </td>
            ) : null}
            {this.headers[8]?.isVisible ? (
              <td>
                <p> {item.roomCount?.toString()}</p>
              </td>
            ) : null}
            {this.headers[9]?.isVisible ? (
              <td>
                <p> {item.estateInfo[0]?.fullName}</p>
              </td>
            ) : null}
            {this.headers[10]?.isVisible ? (
              <td>
                <TruncatedTableCell text={item.address.fullAddress} />
              </td>
            ) : null}
          </tr>
        );
      },
    },
    {
      id: 1,
      headers: [
        {
          id: 0,
          title: "شناسه",
          isVisible: localStorage.getItem(`1-0-visibility`) === "false" ? false : true,
        },
        {
          id: 1,
          title: "متراژ کل",
          isVisible: localStorage.getItem(`1-1-visibility`) === "false" ? false : true,
        },
        {
          id: 2,
          title: "متراژ دهنه",
          isVisible: localStorage.getItem(`1-2-visibility`) === "false" ? false : true,
        },
        {
          id: 3,
          title: "متراژ بالکن",
          isVisible: localStorage.getItem(`1-3-visibility`) === "false" ? false : true,
        },
        {
          id: 4,
          title: props.dealType == 1 ? "رهن" : "کل",
          isVisible: localStorage.getItem(`1-4-visibility`) === "false" ? false : true,
        },
        {
          id: 5,
          title: props.dealType == 1 ? "اجاره" : "متری",
          isVisible: localStorage.getItem(`1-5-visibility`) === "false" ? false : true,
        },
        {
          id: 6,
          title: "موقعیت ملک",
          isVisible: localStorage.getItem(`1-6-visibility`) === "false" ? false : true,
        },
        {
          id: 7,
          title: "نام مالک",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`1-7-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
        {
          id: 8,
          title: "آدرس دقیق",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`1-8-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
      ],
      content(item, props) {
        return (
          <tr key={item.fileCode}>
            {this.headers[0]?.isVisible ? (
              <td>
                <Link to={`/card-detail/${item.id}`}>{item.fileCode?.match(/\d+/)[0]}</Link>
              </td>
            ) : null}
            {this.headers[1]?.isVisible ? (
              <td>
                <p> {item.meterage}</p>
              </td>
            ) : null}
            {this.headers[2]?.isVisible ? (
              <td>
                <p> {item.meterageGate}</p>
              </td>
            ) : null}
            {this.headers[3]?.isVisible ? (
              <td>
                <p> {item.meterageBalkony}</p>
              </td>
            ) : null}
            {this.headers[5]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.mortgagePrice : item.totalPrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[6]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.rentPrice : item.meteragePrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[6]?.isVisible ? (
              <td>
                <p> {item.positions || "نامشخص"}</p>
              </td>
            ) : null}
            {this.headers[7]?.isVisible ? (
              <td>
                <p> {item.estateInfo[0]?.fullName}</p>
              </td>
            ) : null}
            {this.headers[8]?.isVisible ? (
              <td>
                <TruncatedTableCell text={item.address.fullAddress} />
              </td>
            ) : null}
          </tr>
        );
      },
    },
    {
      id: 2,
      headers: [
        {
          id: 0,
          title: "شناسه",
          isVisible: localStorage.getItem(`2-0-visibility`) === "false" ? false : true,
        },
        {
          id: 1,
          title: "متراژ",
          isVisible: localStorage.getItem(`2-1-visibility`) === "false" ? false : true,
        },
        {
          id: 2,
          title: "عرض ملک",
          isVisible: localStorage.getItem(`2-2-visibility`) === "false" ? false : true,
        },
        {
          id: 3,
          title: "عرض گذر",
          isVisible: localStorage.getItem(`2-3-visibility`) === "false" ? false : true,
        },
        {
          id: 4,
          title: "سال ساخت",
          isVisible: localStorage.getItem(`2-4-visibility`) === "false" ? false : true,
        },
        {
          id: 5,
          title: props.dealType == 1 ? "رهن" : "کل",
          isVisible: localStorage.getItem(`2-5-visibility`) === "false" ? false : true,
        },
        {
          id: 6,
          title: props.dealType == 1 ? "اجاره" : "متری",
          isVisible: localStorage.getItem(`2-6-visibility`) === "false" ? false : true,
        },
        {
          id: 7,
          title: "موقعیت ملک",
          isVisible: localStorage.getItem(`2-7-visibility`) === "false" ? false : true,
        },
        {
          id: 8,
          title: "نام مالک",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`2-8-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
        {
          id: 9,
          title: "آدرس دقیق",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`2-9-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
      ],
      content(item, props) {
        return (
          <tr key={item.fileCode}>
            {this.headers[0]?.isVisible ? (
              <td>
                <Link to={`/card-detail/${item.id}`}>{item.fileCode?.match(/\d+/)[0]}</Link>
              </td>
            ) : null}
            {this.headers[1]?.isVisible ? (
              <td>
                <p> {item.meterage}</p>
              </td>
            ) : null}
            {this.headers[2]?.isVisible ? (
              <td>
                <p> {item.landWidth}</p>
              </td>
            ) : null}
            {this.headers[3]?.isVisible ? (
              <td>
                <p> {item.walkawayWidth}</p>
              </td>
            ) : null}
            {this.headers[4]?.isVisible ? (
              <td>
                <p> {item.constructionYear}</p>
              </td>
            ) : null}
            {this.headers[5]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.mortgagePrice : item.totalPrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[6]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.rentPrice : item.meteragePrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[7]?.isVisible ? (
              <td>
                <p> {item.positions || "نامشخص"}</p>
              </td>
            ) : null}
            {this.headers[8]?.isVisible ? (
              <td>
                <p> {item.estateInfo[0]?.fullName}</p>
              </td>
            ) : null}
            {this.headers[9]?.isVisible ? (
              <td>
                <TruncatedTableCell text={item.address.fullAddress} />
              </td>
            ) : null}
          </tr>
        );
      },
    },
    {
      id: 3,
      headers: [
        {
          id: 0,
          title: "شناسه",
          isVisible: localStorage.getItem(`3-0-visibility`) === "false" ? false : true,
        },
        {
          id: 1,
          title: "متراژ",
          isVisible: localStorage.getItem(`3-1-visibility`) === "false" ? false : true,
        },
        {
          id: 2,
          title: "سال ساخت",
          isVisible: localStorage.getItem(`3-2-visibility`) === "false" ? false : true,
        },
        {
          id: 3,
          title: props.dealType == 1 ? "رهن" : "کل",
          isVisible: localStorage.getItem(`3-3-visibility`) === "false" ? false : true,
        },
        {
          id: 4,
          title: props.dealType == 1 ? "اجاره" : "متری",
          isVisible: localStorage.getItem(`3-4-visibility`) === "false" ? false : true,
        },
        {
          id: 5,
          title: "موقعیت ملک",
          isVisible: localStorage.getItem(`3-5-visibility`) === "false" ? false : true,
        },
        {
          id: 6,
          title: "نام مالک",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`3-6-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
        {
          id: 7,
          title: "توضیحات",
          isVisible: localStorage.getItem(`3-7-visibility`) === "false" ? false : true,
        },
        {
          id: 8,
          title: "آدرس دقیق",
          isVisible: ownerDetailLimit ? false : localStorage.getItem(`3-8-visibility`) === "false" ? false : true,
          isDisable: ownerDetailLimit,
        },
      ],
      content(item, props) {
        return (
          <tr key={item.fileCode}>
            {this.headers[0]?.isVisible ? (
              <td>
                <Link to={`/card-detail/${item.id}`}>{item.fileCode?.match(/\d+/)[0]}</Link>
              </td>
            ) : null}
            {this.headers[1]?.isVisible ? (
              <td>
                <p> {item.meterage}</p>
              </td>
            ) : null}
            {this.headers[2]?.isVisible ? (
              <td>
                <p> {item.constructionYear}</p>
              </td>
            ) : null}
            {this.headers[3]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.mortgagePrice : item.totalPrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[4]?.isVisible ? (
              <td>
                <TruncatedTableCell
                  text={e2p(props.usePriceSeprator(props.dealType == 1 ? item.rentPrice : item.meteragePrice))}
                  maxLength={4}
                  style={{
                    direction: "ltr",
                    textAlign: "right",
                  }}
                  tooltipStyle={{
                    width: "fit-content",
                    minWidth: "120px",
                    direction: "ltr",
                    textAlign: "left",
                  }}
                />
              </td>
            ) : null}
            {this.headers[5]?.isVisible ? (
              <td>
                <p> {item.positions || "نامشخص"}</p>
              </td>
            ) : null}
            {this.headers[6]?.isVisible ? (
              <td>
                <p> {item.estateInfo[0]?.fullName}</p>
              </td>
            ) : null}
            {this.headers[7]?.isVisible ? (
              <td>
                <TruncatedTableCell text={item.description}></TruncatedTableCell>
              </td>
            ) : null}
            {this.headers[8]?.isVisible ? (
              <td>
                <TruncatedTableCell text={item.address.fullAddress} />
              </td>
            ) : null}
          </tr>
        );
      },
    },
  ];

  const shopCategories = [304, 280];
  const hotelCategories = [278, 291];
  const gasStationCategories = [309, 316];
  const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];
  const industrialCategories = [311, 312, 313, 314, 318, 319, 320, 321];

  function getFieldsBasedOnType(fileData) {
    let fileCategory = fileData.categoryId;
    if (
      shopCategories.includes(getParentCategory(fileCategory)) ||
      gasStationCategories.includes(getParentCategory(fileCategory)) ||
      hotelCategories.includes(getParentCategory(fileCategory))
    ) {
      return (
        <>
          <div className="d-flex align-items-center justify-content-center flex-column ms-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={meterIcon} alt="icon" />
              <div className={styles.card_text2}>متراژ دهنه: {e2p(fileData.meterageGate?.toString())} متر</div>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={meterIcon} alt="icon" />
              <div className={styles.card_text2}>متراژ کف: {e2p(fileData.meterageBase?.toString())} متر</div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-column me-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={meterIcon} alt="icon" />
              <div className={styles.card_text2}>متراژ کل: {e2p(fileData.meterage?.toString())} متر</div>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={locationIcon} alt="icon" />
              <div className={styles.card_text2}>{fileData.address.zone}</div>
            </div>
          </div>
        </>
      );
    }
    if (landCategories.includes(getParentCategory(fileCategory))) {
      return (
        <>
          <div className="d-flex align-items-center justify-content-center flex-column ms-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={meterIcon} alt="icon" />
              <div className={styles.card_text2}>متراژ کل: {e2p(fileData.meterage?.toString())} متر</div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-column me-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
              <img className="ms-2" src={locationIcon} alt="icon" />
              <div className={styles.card_text2}>{fileData.address.zone}</div>
            </div>
          </div>
        </>
      );
    }
    if (industrialCategories.includes(getParentCategory(fileCategory))) {
      return (
        <>
          <div className="d-flex align-items-center justify-content-center flex-column me-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2" dir="rtl">
              <img className="ms-2" src={meterIcon} alt="icon" />
              <div className={styles.card_text2}>متراژ کل: {e2p(fileData.meterage?.toString())} متر</div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-column me-0">
            <div className="d-flex justify-content-center align-items-center mt-2 mb-2" dir="rtl">
              <img className="ms-2" src={locationIcon} alt="icon" />
              <div className={styles.card_text2}>{fileData.address.zone}</div>
            </div>
          </div>
        </>
      );
    }
    return (
      <>
        <div className="d-flex align-items-center justify-content-center flex-column ms-0">
          <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
            <img className="ms-2" src={bedIcon} alt="icon" />
            <div className={styles.card_text2}>{e2p(fileData.roomCount?.toString())} خوابه</div>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
            <img className="ms-2" src={meterIcon} alt="icon" />
            <div className={styles.card_text2}>متراژ کل: {e2p(fileData.meterage?.toString())} متر</div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center flex-column me-0">
          <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
            <img className="ms-2" src={buildingIcon} alt="icon" />
            <div className={styles.card_text2}>
              {fileData?.floor == "0" ? "همکف" : fileData?.floor == "-1" ? "زیرزمین" : <>طبقه {e2p(fileData.floor?.toString())}</>}
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2 mb-2">
            <img className="ms-2" src={locationIcon} alt="icon" />
            <div className={styles.card_text2}>{fileData.address.zone}</div>
          </div>
        </div>
      </>
    );
  }

  function isRent(category) {
    let selectedCategory = categoriesData.find(c => c.id == category);

    if (selectedCategory?.dealType == 1) {
      return true;
    }
    return false;
  }

  function getTableCategory(categoryId) {
    if (shopCategories.includes(categoryId) || gasStationCategories.includes(categoryId) || hotelCategories.includes(categoryId)) {
      return 1;
    }
    if (landCategories.includes(categoryId)) {
      return 2;
    }
    if (industrialCategories.includes(categoryId)) {
      return 3;
    }
    return 0;
  }

  const tableCategory = getTableCategory(props.selectedSubCategory);

  useEffect(() => {
    let newSelectedTable = tables.find(table => {
      return table.id === tableCategory;
    });

    newSelectedTable.headers = newSelectedTable.headers.filter(col => (col.isDisable ? false : true));

    setSelectedTable(newSelectedTable);
  }, [tableCategory, props?.cardData, ownerDetailLimit]);

  return (
    <>
      <ConsultantLimitationModal
        show={limitationModal.open}
        onHide={() =>
          setLimitationModal(prev => {
            return { ...prev, open: false };
          })
        }
        fileID={limitationModal.fileID}
      />

      <div
        className={` ${
          (props.tableType === "table" && props.selectedSubCategory) ||
          `d-flex justify-content-xl-between justify-content-center flex-wrap align-items-center mt-3 me-3 ${styles.cards_container}`
        } w-100 `}
        dir="rtl"
        style={{
          padding: props.tableType === "table" && props.selectedSubCategory && "0 20px",
          marginTop: "20px",
        }}>
        {props.tableType === "table" && props.selectedSubCategory ? (
          <>
            <style type="text/css">
              {`
                .table-container {
                  width: 100%; /* Set the container width to 100% */
                  overflow-x: auto; /* Add horizontal scrollbar when content exceeds the container width */
                }

                .table {
                  width: 100%; /* Set the table width to 100% */
                  min-width: max-content;     
                  border-collapse: collapse;
                  font-size: 14px;
                  border-right: 1px solid #e0e0e0;
                  border-left: 1px solid #e0e0e0;
                  -webkit-user-select: none;  /* Safari */
                  -ms-user-select: none;      /* IE 10 and IE 11 */
                  user-select: none;  
                }

                .table th,
                .table td {
                  padding: 20px 10px;
                  text-align: start;
                  border-bottom: 1px solid #e0e0e0;
                  
                }

                .table td p {
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  margin: 0;
                }

                .table th {
                  background-color: #f2f2f2;
                }
              `}
            </style>

            {props.cardData?.length ? (
              <>
                <ChangeColumnVisibility
                  selectedTable={selectedTable}
                  onChangeVisibility={columnId => {
                    const newSelectedTableHeader = selectedTable?.headers?.map(header => {
                      if (header.id === columnId) {
                        localStorage.setItem(`${selectedTable.id}-${columnId}-visibility`, (!header.isVisible).toString());
                        return {
                          ...header,
                          isVisible: !header.isVisible,
                        };
                      }

                      return header;
                    });

                    const newSelectedTable = { ...selectedTable };

                    newSelectedTable.headers = newSelectedTableHeader;

                    setSelectedTable(newSelectedTable);
                  }}
                />
                <div
                  className="table-container"
                  style={{
                    position: "relative",
                  }}>
                  <table className="table">
                    <thead>
                      <tr>
                        {selectedTable?.headers?.map(header => {
                          if (!header.isVisible) return null;

                          return <th>{header.title}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {props.cardData?.map(item => {
                        return selectedTable?.content(item, props);
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <div
                style={{
                  padding: "80px 0",
                }}
                className={`w-100 d-flex align-items-center justify-content-center ${styles.notfound_text}`}>
                هنوز هیچ موردی برای نمایش وجود ندارد
              </div>
            )}
          </>
        ) : (
          <>
            {props.cardData == "" || !props.cardData.length ? (
              <div className={`w-100 d-flex align-items-center justify-content-center ${styles.notfound_text}`}>هنوز هیچ موردی برای نمایش وجود ندارد</div>
            ) : props.filterCardsByCategory.forRent === true ? (
              props.cardData?.map((item, i) => (
                <div key={i} className={`d-flex align-items-center flex-column px-2 py-3 mt-3 mb-4 mx-md-3 mx-0 ${styles.card_container}`}>
                  <div className="w-100 position-relative mb-3">
                    <Link
                      to={{
                        pathname: `/card-detail/${item.id}`,
                        state: {
                          pageNumber: props.pageNum,
                          query: props.query,
                          state: item,
                          isArchive: props.isArchive ? true : false,
                          filterCardsByCategory: {
                            forRent: true,
                          },
                        },
                      }}>
                      <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                    </Link>
                    {item.status === 4 && (
                      <span className={`d-flex align-items-center justify-content-center ${styles.card_imgs_nubmer_info}`}>نیاز به تایید</span>
                    )}
                    {item.isAnyChild && <span className={`d-flex align-items-center justify-content-center ${styles.card_multiple_text}`}>چند واحدی</span>}
                  </div>

                  <div className="w-100 text-end px-2 mb-1">
                    <Link
                      to={{
                        pathname: `/card-detail/${item.id}`,
                        state: {
                          pageNumber: props.pageNum,
                          query: props.query,
                          state: item,
                          isArchive: props.isArchive ? true : false,
                          filterCardsByCategory: {
                            forRent: true,
                          },
                        },
                      }}
                      className={styles.card_title}>
                      {e2p(item.title?.toString())}
                    </Link>
                  </div>

                  <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                    <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2">
                      <div className={`ms-2 ${styles.rent_title}`}>رهن:</div>
                      <div className={styles.card_price}>
                        {e2p(props.usePriceSeprator(item.mortgagePrice))}
                        <span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                      </div>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2">
                      <div className={`ms-2 ${styles.rent_title}`}>اجاره:</div>
                      <div className={styles.card_price}>
                        {e2p(props.usePriceSeprator(item.rentPrice))}
                        <span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                      </div>
                    </div>
                  </div>

                  <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap">{getFieldsBasedOnType(item)}</div>

                  <div
                    className={`w-100 d-flex ${
                      permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                        ? "justify-content-between"
                        : "justify-content-end"
                    } align-items-center px-2 mt-2`}>
                    {permissions?.find(item => item === 15) === 15 ? (
                      <button
                        className={styles.limitation__btn}
                        onClick={() =>
                          setLimitationModal(prev => {
                            return { ...prev, open: true, fileID: item.id };
                          })
                        }>
                        افزودن محدودیت
                      </button>
                    ) : (
                      <></>
                    )}
                    <div className="d-flex align-items-center justify-content-center">
                      <Link
                        to={{
                          pathname: `/card-detail/${item.id}`,
                          state: {
                            pageNumber: props.pageNum,
                            query: props.query,
                            state: item,
                            isArchive: props.isArchive ? true : false,
                            filterCardsByCategory: {
                              forRent: true,
                            },
                          },
                        }}
                        className={`ms-1 ${styles.text_primary}`}>
                        مشاهده بیشتر
                      </Link>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path
                          fillRule="evenodd"
                          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                          fill="#21409A"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              props.cardData?.map((item, i) => (
                <div key={i} className={`d-flex align-items-center flex-column px-2 py-3 mt-3 mb-4 mx-md-3 mx-0 ${styles.card_container}`}>
                  <div className="w-100 position-relative mb-3">
                    <Link
                      to={{
                        pathname: `/card-detail/${item.id}`,
                        state: {
                          pageNumber: props.pageNum,
                          query: props.query,
                          state: item,
                          isArchive: props.isArchive ? true : false,
                          filterCardsByCategory: {
                            forRent: false,
                          },
                        },
                      }}>
                      <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                    </Link>
                    {item.status === 4 && (
                      <span className={`d-flex align-items-center justify-content-center ${styles.card_imgs_nubmer_info}`}>نیاز به تایید</span>
                    )}
                    {item.isAnyChild && <span className={`d-flex align-items-center justify-content-center ${styles.card_multiple_text}`}>چند واحدی</span>}
                  </div>

                  <div className="w-100 text-end px-2 mb-1">
                    <Link
                      to={{
                        pathname: `/card-detail/${item.id}`,
                        state: {
                          pageNumber: props.pageNum,
                          query: props.query,
                          state: item,
                          isArchive: props.isArchive ? true : false,
                          filterCardsByCategory: {
                            forRent: false,
                          },
                        },
                      }}
                      className={styles.card_title}>
                      {e2p(item.title?.toString())}
                    </Link>
                  </div>

                  <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                    {isRent(item.categoryId) ? (
                      <>
                        <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2">
                          <div className={`ms-2 ${styles.rent_title}`}>رهن:</div>
                          <div className={styles.card_price}>
                            {e2p(props.usePriceSeprator(item.mortgagePrice))}
                            <span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                          </div>
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2">
                          <div className={`ms-2 ${styles.rent_title}`}>اجاره:</div>
                          <div className={styles.card_price}>
                            {e2p(props.usePriceSeprator(item.rentPrice))}
                            <span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className={styles.card_price}>
                          {e2p(props.usePriceSeprator(item.totalPrice))}
                          <span className={`me-1 ${styles.card_text2}`}>تومان</span>
                        </h4>
                        <h4 className={`d-flex align-items-center justify-content-center ${styles.card_text2}`}>
                          {e2p(props.usePriceSeprator(item.meteragePrice))} تومان هر متر مربع
                        </h4>
                      </>
                    )}
                  </div>

                  <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap">
                    {getFieldsBasedOnType(item)}
                    {/*<div className='d-flex align-items-center justify-content-center flex-column'>
                                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                            <img className="ms-2" src={bedIcon} alt="icon" />
                                            <div className={styles.card_text2}>
                                                {e2p(item.roomCount?.toString())} خوابه
                                            </div>

                                        </div>
                                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                            <img className="ms-2" src={meterIcon} alt="icon" />
                                            <div className={styles.card_text2}>
                                                {e2p(item.meterage?.toString())} متر
                                            </div>

                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-center flex-column'>
                                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                            <img className="ms-2" src={buildingIcon} alt="icon" />
                                            <div className={styles.card_text2}>
                                                {item?.floor == "0" ?
                                                    "همکف"
                                                    :
                                                    item?.floor == "-1" ?
                                                        "زیرزمین"
                                                        :
                                                        <>
                                                            طبقه {e2p(item.floor?.toString())}
                                                        </>
                                                }
                                            </div>

                                        </div>
                                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                            <img className="ms-2" src={locationIcon} alt="icon" />
                                            <div className={styles.card_text2}>
                                                {item.address.zone}
                                            </div>

                                        </div>
                                    </div>*/}
                  </div>

                  <div
                    className={`w-100 d-flex ${
                      permissions?.find(item => item === 15) === 15 || permissions?.find(item => item === 18) === 18
                        ? "justify-content-between"
                        : "justify-content-end"
                    } align-items-center px-2 mt-2`}>
                    {permissions?.find(item => item === 15) === 15 ? (
                      <button
                        className={styles.limitation__btn}
                        onClick={() =>
                          setLimitationModal(prev => {
                            return { ...prev, open: true, fileID: item.id };
                          })
                        }>
                        افزودن محدودیت
                      </button>
                    ) : (
                      <></>
                    )}
                    <div className="d-flex align-items-center justify-content-center">
                      <Link
                        to={{
                          pathname: `/card-detail/${item.id}`,
                          state: {
                            pageNumber: props.pageNum,
                            query: props.query,
                            state: item,
                            isArchive: props.isArchive ? true : false,
                            filterCardsByCategory: {
                              forRent: false,
                            },
                          },
                        }}
                        className={`ms-1 ${styles.text_primary}`}>
                        مشاهده بیشتر
                      </Link>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path
                          fillRule="evenodd"
                          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                          fill="#21409A"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        )}
      </div>
    </>
  );
};

const TruncatedTableCell = ({ text, maxLength = 10, style = {}, tooltipStyle = {} }) => {
  const styles = {
    container: {
      position: "relative",
      width: "100%",
    },
    truncated: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    },
    tooltip: {
      position: "absolute",
      visibility: "hidden",
      backgroundColor: "#333",
      color: "white",
      padding: "8px",
      borderRadius: "4px",
      fontSize: "14px",
      zIndex: 1000,
      top: "-40px",
      left: "0",
      width: "300px",
      maxWidth: "300px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      wordBreak: "break-word",
      transition: "100ms",
      opacity: 0,
    },
  };

  const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return (
    <div
      style={{ ...styles.container, ...style }}
      onMouseEnter={e => {
        const tooltip = e.currentTarget.querySelector(".truncatedTooltip");
        if (tooltip) {
          tooltip.style.visibility = "visible";
          tooltip.style.opacity = "1";
        }
      }}
      onMouseLeave={e => {
        const tooltip = e.currentTarget.querySelector(".truncatedTooltip");
        if (tooltip) {
          tooltip.style.visibility = "hidden";
          tooltip.style.opacity = "0";
        }
      }}>
      <div style={styles.truncated}>{truncatedText}</div>

      {text.length > maxLength && (
        <div className="truncatedTooltip" style={{ ...styles.tooltip, ...tooltipStyle }}>
          {text}
        </div>
      )}
    </div>
  );
};

export default FileManagmentCards;
